import { Text, Tooltip, TooltipProps, useClipboard } from '@chaine/keychaine'
import React from 'react'

interface CopyableTextProps extends Partial<TooltipProps> {
  children: React.ReactNode
  value: string
}

/**
 * A component that copies the given text to the clipboard when clicked.
 */
export const CopyableText = (props: CopyableTextProps) => {
  const { value, children } = props
  const { hasCopied, onCopy } = useClipboard(value)

  return (
    <Tooltip closeOnClick={false} label={hasCopied ? 'Copied!' : 'Click to copy'}>
      <Text
        onClick={(event) => {
          event.stopPropagation()
          onCopy()
        }}
      >
        {children}
      </Text>
    </Tooltip>
  )
}
